import { Injectable } from '@angular/core';
import { BaseNotifier } from '../../shared/notifiers/base-notifier';
import { Ref } from '../../shared/providers/ref';
import { RightPanelState } from '../states/right-panel-state';
import { UbigeoProvider } from '../providers/ubigeo-provider';

@Injectable({ providedIn: 'root' })
export class RightPanelNotifier extends BaseNotifier<RightPanelState> {
  private _lastUbigeoKey = '';

  constructor(ref: Ref) {
    super(ref, {
      visible: false,
      title: 'Detalle',
      componentId: null,
      history: [],
      loading: false,
    });

    this.ref.createEffect(() => {
      const u = this.ref.read(UbigeoProvider).state();
      const key = `${u.selectedDepartment ?? ''}|${u.selectedProvince ?? ''}|${u.selectedDistrict ?? ''}`;
      if (key === this._lastUbigeoKey) return;
      this._lastUbigeoKey = key;
      const s = this.state();
      if (s.componentId !== 'summary') return;
      const level = u.selectedDistrictName && u.selectedDistrictName !== 'Todos los Distritos' ? 'DISTRITAL'
        : u.selectedProvinceName && u.selectedProvinceName !== 'Toda la Región' ? 'PROVINCIAL'
        : 'REGIONAL';
      const name = u.selectedDistrictName && u.selectedDistrictName !== 'Todos los Distritos' ? u.selectedDistrictName
        : u.selectedProvinceName && u.selectedProvinceName !== 'Toda la Región' ? u.selectedProvinceName
        : u.selectedDepartmentName || '';
      this.updateState(s2 => ({ ...s2, title: `PERFIL ${level}` }));
    });
  }

  toggle(): void {
    this.updateState(s => ({ ...s, visible: !s.visible }));
  }

  close(): void {
    this.updateState(s => ({ ...s, visible: false }));
  }

  open(): void {
    this.updateState(s => ({ ...s, visible: true }));
  }

  setTitle(title: string): void {
    this.updateState(s => ({ ...s, title }));
  }

  startLoading(): void {
    this.updateState(s => ({ ...s, loading: true }));
  }

  stopLoading(): void {
    this.updateState(s => ({ ...s, loading: false }));
  }

  showProfile(): void {
    const u = this.ref.read(UbigeoProvider).state();
    const level = u.selectedDistrictName && u.selectedDistrictName !== 'Todos los Distritos' ? 'DISTRITAL'
      : u.selectedProvinceName && u.selectedProvinceName !== 'Toda la Región' ? 'PROVINCIAL'
      : 'REGIONAL';
    const name = u.selectedDistrictName && u.selectedDistrictName !== 'Todos los Distritos' ? u.selectedDistrictName
      : u.selectedProvinceName && u.selectedProvinceName !== 'Toda la Región' ? u.selectedProvinceName
      : u.selectedDepartmentName || '';
    this.showDetail('summary', `PERFIL ${level}`);
  }

  showDetail(componentId: string, title: string): void {
    this.updateState(s => {
      if (!s.componentId) return { ...s, componentId, title, visible: true, history: [], loading: true };
      return {
        ...s,
        componentId,
        title,
        visible: true,
        history: [...s.history, { componentId: s.componentId, title: s.title }],
        loading: true,
      };
    });
    setTimeout(() => this.updateState(s => ({ ...s, loading: false })), 400);
  }

  back(): void {
    this.updateState(s => {
      if (s.history.length === 0) return s;
      const prev = s.history[s.history.length - 1];
      return {
        ...s,
        componentId: prev.componentId,
        title: prev.title,
        history: s.history.slice(0, -1),
      };
    });
  }

  clearDetail(): void {
    this.updateState(s => ({ ...s, componentId: null, visible: false }));
  }
}
